import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";

import {
  ICreateZonalConfigPayload,
  IGetQueryParams,
  IZonalConfigUpdatePayload,
} from "../interfaces/Index";
import ZonalConfigsPage from "components/pages/zonalConfig/ZonalConfigPage";

export const mapStateToProps = (state: any, props: any): any => {
  const { zone } = state;
  return {
    isLoading: state.zonalConfigs.isLoading,
    isError: state.zonalConfigs.isError,
    error: state.zonalConfigs.error,
    isZonalConfigAdded: state.zonalConfigs.isZonalConfigAdded,
    zonalConfigs: state.zonalConfigs.zonalConfigs,
    pagination: state.zonalConfigs.pagination,
    isZonalConfigUpdated: state.zonalConfigs.isZonalConfigUpdated,
    isFetchZonalConfigsLoading: state.zonalConfigs.isFetchZonalConfigsLoading,
    isFetchZonalConfigsError: state.zonalConfigs.isFetchZonalConfigsError,
    zonalConfigDetails: state.zonalConfigs.zonalConfigDetails,
    isZonalConfigDetailsFetched: state.zonalConfigs.isZonalConfigDetailsFetched,
    citiesList: zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    isZonalConfigUploading: state.zonalConfigs.isZonalConfigUploading,
    isZonalConfigUploaded: state.zonalConfigs.isZonalConfigUploaded,
    isZonalConfigUploadingError: state.zonalConfigs.isZonalConfigUploadingError,
    isWarehouseCategoriesFetched:
      state.zonalConfigs.isWarehouseCategoriesFetched,
    warehouseCategories: state.zonalConfigs.warehouseCategories,
    isZonalConfigChildZonesFetched:
      state.zonalConfigs.isZonalConfigChildZonesFetched,
    zonalConfigChildZones: state.zonalConfigs.zonalConfigChildZones,
    isZonalConfigTownsFetched: state.zonalConfigs.isZonalConfigTownsFetched,
    zonalConfigTowns: state.zonalConfigs.zonalConfigTowns,
    isZonalConfigWarehouseNameFetched:
      state.zonalConfigs.isZonalConfigWarehouseNameFetched,
    zonalConfigWarehouseName: state.zonalConfigs.zonalConfigWarehouseName,
    bulkCustomerDetails: state.customer.bulkCustomerDetails,
    isBulkCustomerDetailsFetched: state.customer.isBulkCustomerDetailsFetched,
    isZonalConfigWarehouseListWithStorageBlocksFetched: state.zonalConfigs.isZonalConfigWarehouseListWithStorageBlocksFetched,
    zonalConfigWarehouseListWithStorageBlocks: state.zonalConfigs.zonalConfigWarehouseListWithStorageBlocks,
    customerConfig: state.customer.customerConfig,
    zonalConfigChannelName: state.zonalConfigs.zonalConfigChannelName,
    isFetchCustomerChannelLoading: state.zonalConfigs.isFetchCustomerChannelLoading
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    fetchZonalConfigs: (cityId: string, queryPrams?: IGetQueryParams) =>
      dispatch(actions.getZonalConfigsList(cityId, queryPrams)),
    zonalConfigUpload: (cityId: string, payload: FormData, url: string) =>
      dispatch(actions.zonalBoundaryConfigUpload(cityId, payload, url)),
    zonalCSVBatchUpload: (payload: FormData) =>
      dispatch(actions.zonalServiceCSVBatchUpload(payload)),
    createZonalConfig: (payload: ICreateZonalConfigPayload) =>
      dispatch(actions.createZonalConfig(payload)),
    updateZonalConfig: (id: string, zoneType: string, payload: IZonalConfigUpdatePayload) =>
      dispatch(actions.updateZonalConfig(id, zoneType, payload)),
    clearZonalConfigDetails: () =>
      dispatch(actions.clearZonalConfigDetailsAction()),
    getWarehouseCategories: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.fetchZonalConfigWareHouseNames(queryPrams)),
    getZonalConfigChildZones: (id: string) =>
      dispatch(actions.getZonalConfigChildZonesAction(id)),
    getZonalConfigTowns: (id: string) =>
      dispatch(actions.getZonalConfigTownsAction(id)),
    getZonalConfigWarehouse: (id: string, zoneType: string, zoneStatus: boolean) =>
      dispatch(actions.getZonalConfigWarehouseAction(id, zoneType, zoneStatus)),
    getBulkCustomerDetailsByIdAction: (ids: string[]) =>
      dispatch(actions.getBulkCustomerDetailsByIdAction(ids)),
    clearBulkCustomerDetailsAction: () =>
      dispatch(actions.clearBulkCustomerDetailsAction()),
    getZonalConfigWarehouseListWithStorageBlocks: (id: string, zoneType: string) =>
        dispatch(actions.fetchZonalConfigWarehouseListWithStorageBlocksAction(id, zoneType)),
    fetchCustomerConfig: () => dispatch(actions.fetchCustomerConfig()),
    getZoneCustomerChannelConfig: (ucId: string) => dispatch(actions.getZonalCustomerChannel(ucId)),
  };
};

const ZonalConfigsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ZonalConfigsPage);
export default ZonalConfigsContainer;
